import { themes } from 'kb-shared';
import * as React from 'react';
import styled from 'styled-components';

import UnderlineButton from '../../UnderlineButton';
import { CallToActionBase, CopyBase, TitleBase } from './styled';

const { breakpoints } = themes;

const Title = styled(TitleBase)`
  transform: translateY(-8px);
`;

const Copy = styled(CopyBase)`
  padding-top: 8px;
`;

const CallToAction = styled(CallToActionBase)`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${breakpoints.tabletPortrait}) {
    justify-content: flex-start;
  }
`;

const ButtonContainer = styled.div`
  margin-left: 20px;

  @media (max-width: ${breakpoints.tabletPortrait}) {
    display: flex;
    justify-content: center;
    margin: 20px 0px;
  }
`;

const DismissButtonContainer = styled.div`
  margin-top: 15px;
`;

const Container = styled.div`
  margin: 20px 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

type Props = {
  title: string;
  copy: string;
  ButtonComponent: React.ReactNode;
  onDismiss?: () => void;
};

const ButtonTodo = (props: Props) => {
  const { title, copy, ButtonComponent, onDismiss } = props;
  return (
    <Container>
      <CallToAction>
        <div>
          <Title>{title}</Title>
          <Copy>{copy}</Copy>
          {onDismiss && (
            <DismissButtonContainer>
              <UnderlineButton onClick={onDismiss} label="I dont have insurance" />
            </DismissButtonContainer>
          )}
        </div>
      </CallToAction>
      <ButtonContainer>{ButtonComponent}</ButtonContainer>
    </Container>
  );
};

export default ButtonTodo;
